import React from 'react';
import InfiniteCanvas from './components/InfiniteCanvas.tsx';

function App() {
  return (
    <div className="App">
      <InfiniteCanvas />
    </div>
  );
}

export default App;